module.exports = __webpack_public_path__ + "img/icon 3@3x.13f0b1ec.png";